export default function Logo() {
  return (
    <div>
      <h1>🏝️ Shopping List</h1>
    </div>
  );
}